module.exports = __webpack_public_path__ + "static/media/ellipse.462d5dbf.svg";